import { render, staticRenderFns } from "./VideoSession.vue?vue&type=template&id=37aa62ee&"
import script from "./VideoSession.vue?vue&type=script&lang=js&"
export * from "./VideoSession.vue?vue&type=script&lang=js&"
import style0 from "./VideoSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports